// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2zilf","row":"ProcedureTreatmentSummary_row__1mL9b"};